/**
 * The VAT note line a document prints for a venue outside the VAT register (`taxes_enabled` off):
 * the venue's own wording (settings.vat_exempt_note) exactly as typed — it replaces the whole line —
 * else `defaultLine`, the document's own default. Such a venue always prints it (there is no switch);
 * null for a venue in the register. A missing venue reads as outside the register, as the documents
 * always did (`!venue?.taxes_enabled`).
 */
export function vatExemptNote(venue, defaultLine) {
    if (venue?.taxes_enabled)
        return null;
    return venue?.settings?.vat_exempt_note?.trim() || defaultLine;
}
//# sourceMappingURL=vatExemptNote.js.map